import { useCallback, useEffect, useRef } from 'react'

type IntervalHookOptions = {
  interval: number
  callback: (timestamp: number) => void
}

export function useInterval({ interval, callback }: IntervalHookOptions) {
  const savedCallback = useRef<(timestamp: number) => void>()
  const timerIdRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  const startTimer = useCallback(() => {
    // 清除旧的定时器
    if (timerIdRef.current) {
      clearInterval(timerIdRef.current)
    }
    // 创建新的定时器
    if (interval > 0) {
      timerIdRef.current = setInterval(() => {
        if (savedCallback.current) {
          savedCallback.current(Date.now())
        }
      }, interval)
    }
  }, [interval])

  const stopTimer = useCallback(() => {
    if (timerIdRef.current) {
      clearInterval(timerIdRef.current)
      timerIdRef.current = null
    }
  }, [])

  useEffect(() => {
    startTimer()
    return () => stopTimer()
  }, [])

  return { startTimer, stopTimer }
}
